<template>
    <div id="fullpage_hint" class="fullpage-hint">
        <v-dialog
            v-model="notification_dialog"
            content-class="fullpage-hint__dialog"
            :persistent="true"
        >
            <div class="fullpage-hint__container">
                <div class="fullpage-hint__wrapper">
                    <v-icon 
                        color="#ee3934" 
                        large
                    >
                        icon-report-problem
                    </v-icon>
                    <div class="fullpage-hint__text-container">
                        <span class="fullpage-hint__title">
                            {{ title }}
                        </span>
                        <br>
                        <span class="fullpage-hint__content">
                            {{ content }}
                        </span>
                    </div>
                </div>
                <div v-if="is_show_confirm_btn" class="fullpage-hint__wrapper">
                    <v-btn 
                        class="fullpage-hint__btn"
                        @click="close_notification_dialog"
                    >
                        {{ $t('__fullpage_hint.understood') }}
                    </v-btn>
                </div>
            </div>
        </v-dialog>
    </div>
</template>

<script>
    export default {
        name: 'fullpage_hint',

        props: {
            title: {
                type: String,
                required: true
            },

            content: {
                type: String,
                default: ''
            },

            is_show_confirm_btn: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                notification_dialog: true,
            }
        },

        methods: {
            close_notification_dialog() {
                this.notification_dialog = false;
            },
        },
    }
</script>

<style lang="scss">
    @import '../../../css/mixin.scss';

	.fullpage-hint {
		position: absolute;
        border-radius: 16px;
        text-align: center;

        @include laptop {
            position: fixed;
            top: 8px;
            left: unset;
            right: 56px;
            transform: translate( 0, 0);
            z-index: 0;
        }
        
        &__dialog {
            display: flex;
            justify-content: center;
            box-shadow: none;
        }

        &__container {
            width: auto;
            max-width: 75vw;
            border-radius: 16px !important;
            padding: 1rem;
            background-color: #fff;
            display: flex;
            flex-direction: column;
            align-items: center;
        }

        &__wrapper {
            display: flex;
            padding: 0.25rem 0;
        }
        
        &__text-container {
            padding: 0  1rem;
            font-family: NotoSansCJKtc;
            font-size: 14px;
            line-height: 1.43;
            color: var(--base-dark-blue);
        }

        &__title {
            letter-spacing: 0.5px;
            font-weight: bold;
        }

        &__content {
            letter-spacing: 0.6px;
        }

        &__btn {
            margin-top: 0.5rem;
            width: 6rem;
            height: 2rem !important;
            background-color: var(--base-blue) !important;
            color: white !important;
            border-radius: 1rem;
        }
    }
</style>